import { Box } from "@chakra-ui/core";
import React from "react";
import Search from "../../../../Components/Search";

function SubSearchBar() {
  return (
    <Box marginTop="65.6px" p="10" backgroundColor="#293c43">
      <Search />
    </Box>
  );
}

export default SubSearchBar;
